import { Routes, Route, Link, HashRouter } from "react-router-dom";
import Home from "./pages/Home";
import FormFill from "./pages/FormFill";
import ResetPassword from "./pages/ResetPassword";
import AccountDeletion from "./pages/AccountDeletion";
import Suggestions from "./pages/Suggestions";

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/form/:id" element={<FormFill />} />
        <Route path="/auth/reset" element={<ResetPassword />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        <Route path="/suggestions" element={<Suggestions />} />
        <Route
          path="*"
          element={
            <div style={{ padding: 24 }}>
              <h3>Not found</h3>
              <Link to="/">Go home</Link>
            </div>
          }
        />
      </Routes>
    </HashRouter>
  );
}
